// extracted by mini-css-extract-plugin
export default {"select":"styles_select__SKQCx","subtype":"styles_subtype__HV4Nh"};